import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  Avatar } from '@material-ui/core';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import GuiaApi from '../../api/GuiaApi';

const styles = theme => ({
  dialogTitleTypography: {
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    display: 'inline',
    fontSize: 23
  },
  dialogTitle: {
    display: 'inline-flex',
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12,
    display: 'inline-flex',
  },
  paperTable: {
    // maxHeight: '35vh'
  }
});
const getMuiTheme = () =>
  createTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: '0px',
        },
      },
    }
  });
class FormDialogGuiasLoteRecurso extends React.Component {
  guiaApi = new GuiaApi();
  state = {
    guias: [],
    rowsSelected: [],
    fetching: false,
  }
  componentDidMount = async () => {
    await this.consultarGuiasLoteRecurso();
  }
  consultarGuiasLoteRecurso = async () => {
    this.setState({fetching: true});
    let codGuiasSelecionadas = [];
    for (var i = 0; i < this.props.guiasSelecionadas.length; i++) {
      codGuiasSelecionadas.push(this.props.guiasSelecionadas[i][0]);
    }

    let guias = await this.guiaApi.consultarGuiasLoteRecurso(this.props.numDemonstrativo, this.props.numProtocolo, 
      this.props.codTipoGuia, this.props.seqPrestador === undefined ? 0 : this.props.seqPrestador, codGuiasSelecionadas);
    this.setState({ guias: guias, fetching: false });
  }
  handleClose = () => {
    this.props.handleClose();
  }
  handleClickSave = async () => {
    let guias = [];
    for (var i = 0; i < this.state.rowsSelected.length; i++) {
      guias.push(this.state.guias[this.state.rowsSelected[i]]);
    }
    this.props.handleSave(guias);
  }
  render () {
    const options = {
      customToolbarSelect: () => {},
      print: false,
      download: false,
      selectableRows: 'multiple',
      rowsSelected: this.state.rowsSelected,
      onRowsSelect: (rowsSelected, allRows) => {
         const selected = allRows.map(item => item.dataIndex);
         this.setState({rowsSelected: selected});
      },
      filterType: 'dropdown',
      rowsPerPageOptions: [50, 100, 500, 1000, 1500],
      rowsPerPage: 50,
      viewColumns: false,
      filter: false,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>guia(s) selecionada(s)</Typography>
        },
      }
    };
    const columns = [
      {
        name: 'codGuia',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nº da Guia do Prestador',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Nº da Guia da Operadora',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Carteira',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'processado',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'liberado',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Valor Total Glosado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },      
      {
        name: 'Versão TISS',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value === 1 ? '02.02.01' : '03.02.00'}</Typography>;
          },
        }
      },    
      {
        name: 'fatura',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'ações',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
    ];
    const { open, titulo, codTipoGuia, classes } = this.props;
    const { guias, fetching } = this.state;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          scroll='body'
          fullWidth
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleTypography}>{titulo}</Typography> 
            <Avatar className={classes.avatar}>{guias.length}</Avatar>
          </DialogTitle>
          <DialogContent>
            {fetching ? <LinearProgressBlockScreen />
              : <Paper className={classes.paperTable}>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={guias}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </Paper>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              onClick={this.handleClickSave}
              disabled={this.state.rowsSelected.length === 0}
              color='primary'>
              Adicionar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogGuiasLoteRecurso);
